import { MessageCircle } from "lucide-react";

const WA_URL = "https://wa.me/393933111439?text=" + encodeURIComponent(
  "Ciao! Ho visto il sito MP Coaching e vorrei qualche informazione sui pacchetti di coaching."
);

export const WhatsAppButton = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-button"
    aria-label="Scrivici su WhatsApp"
    className="fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-3 rounded-full bg-[#25D366] text-white font-bold text-xs uppercase tracking-wider shadow-2xl shadow-[#25D366]/30 hover:scale-105 hover:brightness-110 transition-[transform,filter]"
  >
    <MessageCircle className="w-5 h-5" />
    <span className="hidden sm:inline">WhatsApp</span>
  </a>
);
